import { ReactTFC } from "../../../utils/fp/missing-ts-parts";

import { css } from "@emotion/react";

import { SerializedStyles } from "@emotion/react";
import React from "react";
import { fontColor, FONTS, fontSize } from "../../../styles/fonts";
import type { TranslatedValue } from "@swo/storefront";
import { T } from "../../../components/T";

export const StoryLayoutReadingTime: ReactTFC<{
  readingTime: string | TranslatedValue;
  attachStyles?: SerializedStyles;
}> = props => (
  <span
    css={[
      FONTS.SwarovskiFutura300,
      fontColor.black,
      fontSize.x2,
      props.attachStyles,
      css`
        text-align: right;
      `,
    ]}
  >
    <T>{props.readingTime}</T>
  </span>
);
